"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchPagination = void 0;
var linkClick_1 = require("./linkClick");
var searchPagination = function (event) {
    var _a;
    var mainEventData = {
        event: 'search-pagination',
        eventInfo: 'search-pagination',
        search: {
            searchPagination: event.eventData.searchPagination.searchPagination.toString(),
        },
    };
    var linkEventData = (0, linkClick_1.linkClick)(event.eventData.searchPagination.searchPagination.toString(), ((_a = event.eventData.linkClick) === null || _a === void 0 ? void 0 : _a.linkModule) || 'coveo-pager-list', '');
    return [mainEventData, linkEventData];
};
exports.searchPagination = searchPagination;
